import ResetPassword from './ResetPassword.component';

export default ResetPassword;
